import { styles, variants, CollapsibleTheme } from '../CollapsibleStyles.css';
import { multiVariantStyles } from './CollapsibleVariants.css';

/*******************
 * Component Theme
 *******************/

const CollapsibleRedwoodTheme: CollapsibleTheme = {
  baseTheme: '',
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { CollapsibleRedwoodTheme };
